<div class="row full-height" *ngIf="beneficiary">
  <div class="col-12 col-lg-3" *ngIf="id !== 0">
    <app-beneficiary-summary [beneficiary]="beneficiary" page="beneficiaryDetailPage"></app-beneficiary-summary>
  </div>
  <div class="col-12 col-lg-3" *ngIf="id === 0">
    <p class="mt-2">Précisions pour la création d’un nouveau dossier.</p>

    <p class="text-danger">
      <strong> Seuls les nouveaux dossiers rentrant dans le cadre du suivi hors RSA doivent être créés manuellement. </strong>
    </p>

    <p>Les champs visibles à l'écran et marqués d’un astérisque (<span class="text-danger">*</span>) sont obligatoires :</p>

    <p>
      Le <strong>nom d’usage</strong> et <strong>prénom 1</strong> : chiffres et caractères spéciaux non autorisés.<br />
      La <strong>date de naissance</strong> : un format jj/mm/aaaa attendu.<br />
      La <strong>nationalité</strong> : à choisir parmi la liste déroulante.<br />
      L’<strong>adresse</strong>, le <strong>code postal</strong> et la <strong>ville</strong>.<br />
      La <strong>date de début</strong> d’accompagnement.<br />
      Le <strong>type</strong> d’accompagnement : choisir un type d'accompagnement, préciser si besoin le type d'accompagnement dans le champ Détails.
    </p>
    <p>
      Les autres champs ne sont pas bloquants pour la création du dossier mais certains restent toutefois indispensables pour un
      <u>dossier de suivi d’un participant dans une action cofinancée par le FSE</u> :<br />
      La <strong>civilité</strong> : à cocher parmi Mme ou M.<br />
      La <strong>ville de naissance</strong>.
    </p>
    <p>Après la sauvegarde de ce premier formulaire d’état civil, les autres onglets Complément, Emploi et Documents seront accessibles.</p>
  </div>
  <div class="col-12 col-lg-9 border-start bg-white px-0">
    <ul class="nav-tabs nav-fill" (navChange)="onNavChange($event)" ngbNav #nav="ngbNav" [(activeId)]="activeTabId">
      <li [ngbNavItem]="'personaldata'">
        <a ngbNavLink><h5 class="text-secondary">État civil</h5></a>
      </li>
      <li [ngbNavItem]="'complement'" [disabled]="id === 0" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+', 'MMIE']">
        <a ngbNavLink><h5 class="text-secondary">Complément</h5></a>
      </li>
      <li [ngbNavItem]="'employment'" [disabled]="id === 0" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+', 'MMIE']">
        <a ngbNavLink><h5 class="text-secondary">Emploi</h5></a>
      </li>
      <li [ngbNavItem]="'documents'" [disabled]="id === 0" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+', 'MMIE']">
        <a ngbNavLink><h5 class="text-secondary" id="documentsTitle">Documents</h5></a>
      </li>
    </ul>
    <router-outlet></router-outlet>
  </div>
</div>
